<template>
  <el-footer
    height="auto"
    :class="{ show_cookies: show_cookies }"
  >
    <div class="footer container">
      <div class="top">
        <div class="icon">
          <a
            target="_blank"
            href="https://www.facebook.com/pppoker123"
            aria-label
            class="facebook-img"
          />
          <a
            target="_blank"
            href="https://www.instagram.com/pppokerglobal"
            aria-label
            class="instagram-img"
          />
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UCpklAxJQBUEoFISwCn9o4jg?view_as=subscriber"
            aria-label
            class="youtube-img"
          />
          <!-- <a
            target="_blank"
            href="https://twitter.com/pppokerofficial"
            aria-label
            class="twitter-img"
          /> -->
        </div>
        <div class="download">
          <a
            id="footfbAndroidDL"
            aria-label
            target="_blank"
            :href="FB_VERSON"
            @click="toBury('officialwebsite_pc_bottom_download_android', 1009, 1, 0, 0, 13)"
          >
            <img
              src="/official/static/img/home/download_08.png"
              alt
            >
          </a>
          <a
            id="footappstoreDL"
            aria-label
            target="_blank"
            href="https://apps.apple.com/in/app/pppoker-nlh-plo-ofc/id1101622978"
            @click="toBury('officialwebsite_pc_bottom_homepage_download_appstore', 1009, 1, 0, 0, 14)"
          >
            <img
              src="/official/static/img/home/download_06.png"
              alt
            >
          </a>
          <a
            id="footgoogleplayDl"
            aria-label
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.lein.pppoker.android"
            @click="toBury('officialwebsite_pc_bottom_homepage_download_googleplay', 1009, 1, 0, 0, 15)"
          >
            <img
              src="/official/static/img/home/download_05.png"
              alt
            >
          </a>
          <a
            id="footwindowsDL"
            aria-label
            target="_blank"
            :href="PC_VERSON"
            @click="toBury('officialwebsite_pc_bottom_homepage_download_windows', 1009, 1, 0, 0, 16)"
          >
            <img
              src="/official/static/img/home/download_07.png"
              alt
            >
          </a>
        </div>
      </div>
      <el-divider />
      <div class="middle">
        <div class="middle_url">
          <a
            target="_blank"
            href="/about"
            aria-label
          >{{ $t('common.p24') }}</a>
          <br>
          <a
            target="_blank"
            href="/legal-affairs/Terms"
            aria-label
          >{{ $t('common.p27') }}</a>
        </div>
        <div class="middle_url">
          <a
            target="_blank"
            href="/brand"
            aria-label
          >{{ $t('common.p25') }}</a>
          <br>
          <a
            target="_blank"
            href="/legal-affairs/Community"
            aria-label
          >{{ $t('common.p28') }}</a>
        </div>
        <div class="middle_url">
          <a
            target="_blank"
            href="/legal-affairs/Privacy"
            aria-label
          >{{ $t('common.p26') }}</a>
          <br>
          <a
            target="_blank"
            href="/legal-affairs/Unsolicited"
            aria-label
          >{{ $t('common.p29') }}</a>
        </div>
        <div
          class="submit"
          :class="{if_valid: if_valid}"
        >
          <el-input
            v-model.trim="input"
            :placeholder="$t('common.p22')"
            @input="inputChange"
          />
          <el-button @click="sumit">
            {{ $t('common.p23') }}
          </el-button>
        </div>
      </div>
      <div class="middle">
        <div class="middle_url">
          <a
            target="_blank"
            href="/legal-affairs/Public"
            aria-label
          >{{ $t('common.p112') }}</a>
        </div>
      </div>
      <div class="copyright">
        <i18n path="common.p30">
          <p
            place="year"
            style="color: white;"
          >
            {{ new Date().getFullYear() }}
          </p>
        </i18n>
        <img
          class="logo"
          src="/official/static/img/home/logo_01.svg"
          alt="logo"
        >
      </div>
    </div>

    <div
      v-if="show"
      class="pops"
    >
      <div class="dark" />
      <transition name="special-effect">
        <div
          v-if="subscribe_step === 1"
          class="sub_step1 home-p-color"
        >
          <img
            class="subscribe_01"
            src="/official/static/img/home/subscribe_01.jpg"
          >
          <div class="content">
            <p class="c_title home-color">
              {{ $t('common.p98') }}
            </p>
            <p>{{ $t('common.p99') }}</p>
            <p class="error">
              {{ subscribe_error }}
            </p>
            <el-input
              v-model.trim="input"
              :placeholder="$t('common.p100')"
              @input="subscribeChange"
            />
            <div
              class="sub_button"
              @click="subscribe_sumit"
            >
              <p>{{ $t('common.p101') }}</p>
            </div>
            <el-checkbox v-model="checked">
              {{ $t('common.p102') }}
            </el-checkbox>
          </div>
          <img
            class="subscribe_close"
            src="/official/static/img/home/subscribe_close.png"
            @click="closeDialog"
          >
        </div>
      </transition>

      <transition name="special-effect">
        <div
          v-if="subscribe_step === 2"
          class="sub_step2 home-p-color"
        >
          <div class="content">
            <p>{{ $t('common.p32') }}</p>
            <p style="margin-bottom: 28px;">
              {{ $t('common.p33') }}
            </p>
            <p class="cont-bottom">
              {{ $t('common.p34') }}
            </p>
            <p class="cont-bottom">
              {{ $t('common.p35') }}
            </p>
          </div>
          <img
            class="subscribe_02"
            src="/official/static/img/home/subscribe_02.jpg"
          >
          <div
            class="sub_button"
            @click="closeDialog"
          >
            <p>{{ $t('common.p39') }}</p>
          </div>
          <img
            class="subscribe_close"
            src="/official/static/img/home/subscribe_close.png"
            @click="closeDialog"
          >
        </div>
      </transition>
    </div>

    <transition name="el-fade-in">
      <div
        v-if="show_cookies"
        class="cookies_fixed"
      >
        <i18n
          path="common.p109"
          tag="p"
          class="p1"
        >
          <template slot="link">
            <a
              style="box-shadow: 0 1px;"
              target="_blank"
              href="/legal-affairs/Cookies"
            >{{ $t('common.p111') }}</a>
          </template>
        </i18n>
        <div
          class="cookies_button"
          @click="closeCookesPop"
        >
          <p>{{ $t('common.p110') }}</p>
        </div>
      </div>
    </transition>
  </el-footer>
</template>

<script>
// @ is an alias to /src
import { receiveUserEmail } from '@/api/official'
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      input: '',
      show: false,
      PC_VERSON: '',
      FB_VERSON: '',
      checked: false,
      subscribe_error: '',
      subscribe_step: 0,
      if_valid: false,
      show_cookies: false
    }
  },
  created () {
    // eslint-disable-next-line no-undef
    this.PC_VERSON = PC_VERSON
    // eslint-disable-next-line no-undef
    this.FB_VERSON = FB_VERSON
  },
  mounted () {
    setTimeout(() => {
      let subscribe =  Cookies.get('subscribe')
      if(!subscribe || (this.getNowDate() > subscribe)) {
        this.show = true
        this.$nextTick(() => {
          this.subscribe_step = 1
        })
      }
    }, 30000)

    let cookiesPop =  Cookies.get('cookiesPop')
    if(!cookiesPop) {
      this.show_cookies = true
    }
  },
  methods: {
    getNowDate () {
      let date = new Date()
      return date.getFullYear() + '-' + (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1) + '-' + date.getDate()
    },
    closeCookesPop () {
      this.show_cookies = false
      Cookies.set('cookiesPop', true)
    },
    inputChange (val) {
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(val)) {
        this.if_valid = false
      }else {
        this.if_valid = true
      }
    },
    subscribeChange (val) {
      // eslint-disable-next-line no-useless-escape
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(val)) {
        this.subscribe_error = this.$t('common.p104')
      }else {
        this.subscribe_error = ''
      }
    },
    closeDialog () {
      this.show = false
      this.input = ''
      if(this.checked) {
        Cookies.set('subscribe', this.getNowDate(), { expires: 1000 })
      }
    },
    subscribe_sumit() {
      var email = this.input
      // eslint-disable-next-line no-useless-escape
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(email)) {
        this.subscribe_error = this.$t('common.p104')
      } else {
        var t = Date.parse(new Date())
        // eslint-disable-next-line no-undef
        var sign = hex_md5(email + '|' + t)

        receiveUserEmail({
          email,
          time: t,
          sign
        })
          .then(() => {
            this.subscribe_step = 2
            Cookies.set('subscribe', '2100-01-01', { expires: 1000 })
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    sumit () {
      var email = this.input
      // eslint-disable-next-line no-useless-escape
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(email)) {
        alert(this.$t('common.p104').replace('*', ''))
      } else {
        var t = Date.parse(new Date())
        // eslint-disable-next-line no-undef
        var sign = hex_md5(email + '|' + t)

        receiveUserEmail({
          email,
          time: t,
          sign
        })
          .then(() => {
            Cookies.set('subscribe', '2100-01-01', { expires: 1000 })
            this.subscribe_step = 2
            this.show = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    toBury (key, f1, f2, f3, f4, f5) {
      this.$gtag.event(key, {
        'event_category': 'download',
        'event_label': 'button',
        'value': 1
      })
      this.$axios.get(
        'https://client-click-v2.cn-hongkong.log.aliyuncs.com/logstores/client-logstroe/track',
        {
          params: {
            APIVersion: '0.6.0',
            __topic__: key,
            f1,
            f2,
            f3,
            f4,
            f5,
            log_type: 10001
          }
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.special-effect-enter-active,
.special-effect-leave-active {
  transition: all 1s;
}
.special-effect-enter,
.special-effect-leave-to {
  margin-top: 50px;
  opacity: 0;
}

.el-footer {
  position: relative;
  font-size: 14px;
  color: #fff;
  // background: url("/official/static/img/home/bg_03.png") center top;
  // background-repeat: no-repeat;
  background-color: #000;
  // margin-top: -74px;
  .footer {
    position: relative;
    height: 500px;
    padding: 0px 10px;
    .top {
      position: relative;
      padding-top: 95px;
      .icon {
        display: inline-block;
        margin-top: 20px;
        a {
          margin: 0 10px;
          display: inline-block;
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center center;
          width: 24px;
          height: 32px;
        }
        .facebook-img {
          background-image: url(/official/static/img/home/2_facebook_w.svg);
          &:hover {
            background-image: url(/official/static/img/home/2_facebook_g.svg);
          }
        }
        .instagram-img {
          background-image: url(/official/static/img/home/2_ins_w.svg);
          &:hover {
            background-image: url(/official/static/img/home/2_ins_g.svg);
          }
        }
        .youtube-img {
          background-image: url(/official/static/img/home/2_youtube_w.svg);
          &:hover {
            background-image: url(/official/static/img/home/2_youtube_g.svg);
          }
        }
        .twitter-img {
          background-image: url(/official/static/img/home/2_twitter_w.svg);
          &:hover {
            background-image: url(/official/static/img/home/2_twitter_g.svg);
          }
        }
      }
      .download {
        float: right;
        a {
          margin: 0 10px;
        }
        a img {
          -o-transition: all cubic-bezier(.165,.84,.44,1) .3s;
          transition: all cubic-bezier(.165,.84,.44,1) .3s;
          -webkit-transform: scale(1);
          -ms-transform: scale(1);
          transform: scale(1);
        }
        a:hover img {
          -webkit-transform: scale(1.1);
          -ms-transform: scale(1.1);
          transform: scale(1.1);
        }
      }
    }
    .el-divider--horizontal {
      margin: 50px 0px;
      background-color: #dfdfdf;
      opacity: 0.37;
    }
    .middle {
      position: relative;
      .middle_url {
        display: inline-block;
        margin-right: 70px;
        a {
          font-size: 14px;
          margin: 8px 0px;
          display: inline-block;
          &:hover {
            color: #1f9d56;
          }
        }
      }
      .submit {
        position: absolute;
        display: inline-block;
        top: 15px;
        right: 10px;
        .el-input {
          width: 280px;
          // margin-right: 3px;
          vertical-align: middle;
          /deep/.el-input__inner {
            // color: #797979;
            color: #1f9d56;
            background-image: url(/official/static/img/home/submit_bg_01.jpg);
            background-repeat: repeat;
            border: none;
            border-radius: 0px;
          }
        }
        .el-button {
          vertical-align: middle;
          border-radius: 0px;
          color: #1f9d56;
          background-image: url(/official/static/img/home/submit_bg_02.jpg);
          background-repeat: repeat;
          font-size: 16px;
          height: 40px;
          padding: 12px 14px;
          border: none;
          // &:active {
          // }
        }
      }
      .submit.if_valid {
        .el-button {
          background-color: #1f9d56;
          background-image: none;
          color: #fff;
        }
      }
    }
    .copyright {
      position: relative;
      padding-top: 110px;
      p {
        display: inline-block;
        color: #898989;
      }
      .logo {
        width: 117px;
        float: right;
      }
    }
  }

  .pops {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    // top: 20%;
    // left: 50%;
    // width: 660px;
    // margin-left: -330px;
    z-index: 3000;
    .dark {
      background-color: #000000;
      filter: Alpha(opacity=60);
      -moz-opacity: 0.6;
      opacity: 0.6;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .pop {
      position: absolute;
      top: 20%;
      left: 50%;
      width: 660px;
      margin-left: -330px;
    }
    .sub_step1 {
      position: absolute;
      top: 25%;
      left: 50%;
      width: 860px;
      // height: 350px;
      margin-left: -470px;
      background-color: #eee;
      padding: 40px 40px;
      z-index: 3500;
      .subscribe_01 {
        width: 340px;
        display: inline-block;
        vertical-align: middle;
      }
      .subscribe_close {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 0px;
        right: 0px;
        padding: 10px 14px;
        display: block;
        cursor: pointer;
      }
      .content {
        display: inline-block;
        width: 500px;
        vertical-align: middle;
        margin-left: 20px;
        p {
          font-size: 18px;
          line-height: 22px;
        }
        .c_title {
          font-size: 30px;
          margin-bottom: 16px;
          margin-top: 4px;
        }
        .error {
          font-size: 16px;
          line-height: 26px;
          color: #942321;
          min-height: 26px;
        }
        .sub_button {
          width: 100%;
          height: 44px;
          background-color: #1f9d56;
          margin: 20px 0px;
          cursor: pointer;
          p {
            font-size: 28px;
            line-height: 44px;
            text-align: center;
            color: #fff;
          }
        }
        /deep/.el-input__inner {
          font-size: 18px;
          height: 44px;
          color: #1f9d56;
        }
        /deep/.el-checkbox {
          font-size: 16px;
          line-height: 26px;
        }
        /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
          font-size: 16px;
          color: #606266;
        }
        /deep/.el-checkbox__label {
          font-size: 16px;
          a {
            box-shadow: 0 1PX;
          }
        }
      }
    }
    .sub_step2 {
      position: absolute;
      top: 25%;
      left: 50%;
      width: 640px;
      // height: 350px;
      margin-left: -360px;
      background-color: #eee;
      padding: 50px 40px 36px 40px;
      z-index: 3500;
      .subscribe_02 {
        width: 258px;
        display: inline-block;
        vertical-align: top;
        margin-left: 20px;
      }
      .subscribe_close {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 0px;
        right: 0px;
        padding: 10px 14px;
        display: block;
        cursor: pointer;
      }
      .content {
        display: inline-block;
        width: 360px;
        vertical-align: top;
        p {
          font-size: 22px;
          line-height: 28px;
        }
        .cont-bottom {
          font-size: 18px;
          line-height: 26px;
          text-align: left;
        }
        .sub_button {
          width: 100%;
          height: 44px;
          background-color: #1f9d56;
          margin: 20px 0px;
          cursor: pointer;
          p {
            font-size: 28px;
            line-height: 44px;
            text-align: center;
            color: #fff;
          }
        }
      }
      .sub_button {
        width: 100%;
        height: 44px;
        background-color: #1f9d56;
        margin-top: 20px;
        cursor: pointer;
        p {
          font-size: 28px;
          line-height: 44px;
          text-align: center;
          color: #fff;
        }
      }
    }
    .f-dialog {
      width: 100%;
      height: auto;
      z-index: 3500;
      position: relative;
      background-color: #fff;
      padding-bottom: 40px;
      border-radius: 4px;
      .f-t-close {
        position: relative;
        height: 46px;
        width: 238px;
        // top: 0px;
        // right: 0px;
        // background-image: url("/official/static/img/dialog/button.png");
        // background-repeat: no-repeat;
        // background-size: contain;
        background-color: #1f9d56;
        border-radius: 4px;
        margin: 26px auto 0px auto;
        cursor: pointer;
        p {
          color: #fff;
          line-height: 46px;
          font-size: 26px;
          text-align: center;
        }
      }
      .f-title {
        width: 100%;
        height: 120px;
        position: relative;
        .f-t-title {
          height: 140px;
          width: 100%;
          display: inline-block;
          // background-image: url("/official/static/img/dialog/title.jpg");
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          p {
            font-size: 60px;
            color: #1f9d56;
            font-weight: bold;
          }
        }
      }
      .f-content {
        width: 100%;
        // height: 287px;
        // background-image: url("/official/static/img/dialog/bg.jpg");
        // background-repeat: repeat;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // align-items: flex-start;
        p {
          padding: 0 30px;
          // text-align: center;
          font-size: 24px;
          line-height: 32px;
          color: #727272;
        }
      }
    }
  }

  .cookies_fixed {
    position: fixed;
    z-index: 100;
    left: 0px;
    bottom: 0px;
    width: 100%;
    // border-top: 1px solid #252525;
    padding: 13px 0px;
    background-color: rgba(69, 69, 69, 0.6);
    .p1 {
      font-size: 16px;
      color: #ffffff;
      line-height: 20px;
      padding: 4px 20px;
      margin-right: 20px;
      display: inline-block;
    }
    .cookies_button {
      display: inline-block;
      width: 133px;
      height: 28px;
      background-color: #1f9d56;
      border-radius: 4px;
      border: solid 1px #1f9d56;
      margin-left: 20px;
      text-align: center;
      cursor: pointer;
      p {
        font-size: 20px;
        color: #ffffff;
        line-height: 28px;
      }
    }
  }
}
.el-footer.show_cookies {
  padding-bottom: 56px;
}
</style>
